import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import {
  type Control,
  Controller,
  type UseFormSetValue,
} from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { STATUS_COMMENT_TAG_OPTIONS } from './constants';

interface StatusCommentSectionProps {
  control: Control<any>;
  statusComment: string;
  setValue: UseFormSetValue<any>;
  disabled?: boolean;
  required?: boolean;
}

export function StatusCommentSection({
  control,
  statusComment,
  setValue,
  disabled = false,
  required = false,
}: StatusCommentSectionProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-1">
      <label className="text-sm font-medium text-gray-700">
        {t('embryo.statusComment', { defaultValue: 'Comment' })}
        {required && <span className="ml-0.5 text-red-500">*</span>}
      </label>
      <Controller
        name="statusComment"
        control={control}
        render={({ field, fieldState }) => (
          <>
            <InputTextarea
              {...field}
              value={field.value || ''}
              rows={3}
              autoResize
              disabled={disabled}
              className={`w-full resize-none text-sm ${fieldState.invalid ? 'p-invalid' : ''}`}
              onChange={(e) => field.onChange(e.target.value)}
            />
            {fieldState.error && (
              <small className="p-error">{fieldState.error.message}</small>
            )}
          </>
        )}
      />
      <div className="mt-1 flex flex-wrap gap-1">
        {STATUS_COMMENT_TAG_OPTIONS.map((tag) => (
          <Button
            key={tag}
            label={tag}
            size="small"
            outlined
            type="button"
            disabled={disabled}
            className="h-6 px-2 text-[10px]"
            onClick={() => {
              const lines = (statusComment || '').split('\n');
              const idx = lines.indexOf(tag);
              if (idx !== -1) lines.splice(idx, 1);
              else lines.push(tag);
              setValue('statusComment', lines.filter(Boolean).join('\n'), {
                shouldDirty: true,
              });
            }}
          />
        ))}
      </div>
    </div>
  );
}
